import { render, staticRenderFns } from "./people_drain.vue?vue&type=template&id=de8158a0&scoped=true"
import script from "./people_drain.vue?vue&type=script&lang=js"
export * from "./people_drain.vue?vue&type=script&lang=js"
import style0 from "./people_drain.vue?vue&type=style&index=0&id=de8158a0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de8158a0",
  null
  
)

export default component.exports